import React from 'react';

import Label from '../../../components/plain/Label';
import FieldString from '../../../components/plain/FieldString';

import {getDefinedItem } from '../../../util/tools';

class FieldGlobalId extends React.Component {
	
	/*
		instance
		plain
		label
			title
			tooltip
		styles
			input
	*/
	constructor(props) {
		super(props);
	}
	
	render() {
		
		let instance = this.props.instance;
		let plain = this.props.plain;
		let readOnly = instance.id > 0;
		
		let labelTitle = getDefinedItem(this.props, ['label', 'title'], 'Ідентифікатор УІК');
		let labelTooltip = getDefinedItem(this.props, ['label', 'title'], 'Ідентифікатор УІК');
		let inputStyle = getDefinedItem(this.props, ['styles', 'input'], {});
		
		return(
			<React.Fragment>
				<Label title={labelTitle} tooltip={labelTooltip} styles={{divMain: {marginRight: '10px'}}} />
				<FieldString instance={instance} path={'/globalId'} plain={plain} readOnly={readOnly}
					styles={{ input: inputStyle }}
				/>
			</React.Fragment>
		);
	}
	
}

export default FieldGlobalId;
